import validate from "validate.js";
import { maxLength, ValidationField, Validator } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
export class KeiyakushaFindConditionValidator extends Validator {
    constructor(data) {
        const constraints = {
            userCd: {
                length: maxLength(8),
                hasMinimumConditions: hasMinimumConditions(data, commonStore.messages.PV0021)
            },
            userName: {
                length: maxLength(30),
                hasMinimumConditions: hasMinimumConditions(data, commonStore.messages.PV0021)
            },
            buknCd: {
                length: maxLength(8),
                hasMinimumConditions: hasMinimumConditions(data, commonStore.messages.PV0021)
            },
            buknName: {
                length: maxLength(30),
                hasMinimumConditions: hasMinimumConditions(data, commonStore.messages.PV0021)
            }
        };
        super(data, constraints);
        this.userCd = new ValidationField("userCd", data, constraints);
        this.userName = new ValidationField("userName", data, constraints);
        this.buknCd = new ValidationField("buknCd", data, constraints);
        this.buknName = new ValidationField("buknName", data, constraints);
    }
    userCd;
    userName;
    buknCd;
    buknName;
}
/** 検索ボタン押下時かつ、検索条件の「契約者コード」「契約者名」「物件コード」「物件名」が全て空かをチェックする */
validate.validators.hasMinimumConditions = function (value, options, key, attributes) {
    if (!options.vm.isSearch) {
        return null;
    }
    if (isNullOrUndefined(options.vm.userCd) &&
        (isNullOrUndefined(options.vm.userName) || options.vm.userName === "") &&
        isNullOrUndefined(options.vm.buknCd) &&
        (isNullOrUndefined(options.vm.buknName) || options.vm.buknName === "")) {
        return options.message;
    }
    return null;
};
export function hasMinimumConditions(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
